/** «1 запис», «2 записи», «5 записів» — українська множина для лічильника історії номера. */
export function formatRecordsCount(n) {
  const mod10 = n % 10;
  const mod100 = n % 100;
  let word = 'записів';
  if (mod10 === 1 && mod100 !== 11) word = 'запис';
  else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) word = 'записи';
  return `${n} ${word}`;
}
